import CustomerBrandbook from './CustomerBrandbook'

export default CustomerBrandbook
